import { GetStaticPaths, GetStaticProps } from 'next';

import Page from '@/components/page';
import getPageStaticPaths from '@/lib/get-page-static-paths';
import getPageStaticProps from '@/lib/get-page-static-props';
import contentService from '@/middleware/content-service';
import mapToPageEntry from '@/middleware/mappers/pages/meme';
import { PageProps } from '@/types/views/generic';

export const getStaticProps: GetStaticProps<PageProps> = getPageStaticProps({
  fetchPageFn: contentService.getPage(mapToPageEntry),
  getPageFullPath: ({ params }) => `/watch/memes/${params?.slug}`,
  staticPagePath: 'watch',
});

export const getStaticPaths: GetStaticPaths = getPageStaticPaths;

export default Page;
